// extracted by mini-css-extract-plugin
module.exports = {"mask":"CenteredHeader_mask__dI70w"};